import { createSlice } from "@reduxjs/toolkit";
import { CheckoutInitialStore } from "./types.store";
import {
  handleGetCheckoutItemsRequest,
  handleGetScheduledCheckoutItemsRequest,
} from "./thunk.store";

const initialState: CheckoutInitialStore = {
  checkoutItems: [],
  scheduledCheckoutItems: [],
  checkoutItemsPagination: {
    limit: 10,
    offset: 0,
    keyset: "",
    count: 0,
    totalCount: 0,
  },
  scheduledCheckoutItemsPagination: {
    limit: 10,
    offset: 0,
    keyset: "",
    count: 0,
    totalCount: 0,
  },
};

const CheckoutStore = createSlice({
  initialState,
  name: "checkoutData",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      handleGetCheckoutItemsRequest.fulfilled,
      (state, action) => {
        state.checkoutItems = action.payload.data ?? [];
        state.checkoutItemsPagination = action.payload.pagination;
      },
    );
    builder.addCase(
      handleGetScheduledCheckoutItemsRequest.fulfilled,
      (state, action) => {
        state.scheduledCheckoutItems = action.payload.data ?? [];
        state.scheduledCheckoutItemsPagination = action.payload.pagination;
      },
    );
  },
});

export default CheckoutStore.reducer;
